import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "a",
        x1: "50%",
        x2: "50%",
        y1: "100%",
        y2: "0%"
      }, [
        _createElementVNode("stop", {
          offset: "0%",
          "stop-color": "#1267EF"
        }),
        _createElementVNode("stop", {
          offset: "100%",
          "stop-color": "#0BEADE"
        })
      ])
    ], -1),
    _createElementVNode("path", {
      fill: "url(#a)",
      "fill-rule": "nonzero",
      d: "M8.306.258 14.095 4.4c.568.406.905 1.06.905 1.758v6.678A2.17 2.17 0 0 1 12.829 15h-2.96v-3.147c0-1.304-1.061-2.361-2.369-2.361a2.365 2.365 0 0 0-2.368 2.36V15h-2.96A2.17 2.17 0 0 1 0 12.836V6.158C0 5.46.337 4.806.905 4.4L6.695.258a1.385 1.385 0 0 1 1.61 0"
    }, null, -1)
  ])))
}
export default { render: render }